const resultsQuery = [{
  path: 'query/index',
  component: resolve => require(['../../../../components/pages/studentresults/resultsquery/ResultsQuery'], resolve)
}, {
  path: 'query/detail',
  component: resolve => require(['../../../../components/pages/studentresults/resultsquery/ResultsDetail'], resolve)
}]
export default resultsQuery



// WEBPACK FOOTER //
// ./src/router/pages/studentresults/resultsquery/index.js